// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://azyixwxndwhaiimqybmd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF6eWl4d3huZHdoYWlpbXF5Ym1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4ODQzNjcsImV4cCI6MjA3MTQ2MDM2N30.RRklKxhMxYbxbiA4gHjCMfy5ef6oaI8cYT93b9pB8pA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase: any = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});